import React from 'react';

import Text from '../text/text';
import { makeClassNames } from '../../../utils/styles';
import './substitute-trainer.scss';

const classNames = () =>
  makeClassNames({
    trainer: 'substitute-players__trainer',
  });

const cn = classNames();

export interface ISubstituteTrainer {
  name: string;
  prefix: string;
  points?: number;
}

const SubstituteTrainer = (props: ISubstituteTrainer) => {
  const { name, prefix, points = 'S.V.' } = props;

  return (
    <div className={cn.trainer}>
      <Text color="blue" fontSize="16" fontWeight="500" tag="span">
        {prefix} {name}
      </Text>
      <Text color="blue" fontSize="16" fontWeight="500">
        {points}
      </Text>
    </div>
  );
};

export default SubstituteTrainer;
